import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { List } from 'immutable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subject } from 'rxjs/Subject';
import { AgencyLookupHttpService } from './agency-lookup.http.service';
import { LookupStore } from '../lookup.store';
import { AgencyLookupSummary } from '../../models/agency-lookup-summary';
import { AgencyLookupDetail } from '../../models/agency-lookup-detail';
import { FlashMessagesService } from '../../flash-messages/service/flash.messages.service';
import { LogService } from '../../log/log.service';

@Injectable()
export class AgencyLookupStore implements LookupStore<AgencyLookupSummary, AgencyLookupDetail> {
  private mySelectedResults: Subject<AgencyLookupDetail> = new Subject();
  private mySearchResults: BehaviorSubject<List<AgencyLookupSummary>> = new BehaviorSubject(List([]));

  constructor(private propertyLookupService: AgencyLookupHttpService,
              private logService: LogService,
              private flashMessagesService: FlashMessagesService) {
  }

  get selected(): Observable<AgencyLookupDetail> {
    return this.mySelectedResults.asObservable().share();
  }

  get searchResults(): Observable<List<AgencyLookupSummary>> {
    return this.mySearchResults.asObservable().share();
  }

  clearSearchResults(): void {
    this.mySearchResults.next(List([]));
  }

  search(searchText: string): Observable<List<AgencyLookupSummary>> {
    this.logService.debug(`searchText: ${searchText}`);

    return this.propertyLookupService.search(searchText)
      .catch((error: any) => {
        this.flashMessagesService.warn('MESSAGES.ERROR.AGENCY_LOOKUP_SEARCH', `Error retrieving AgencyLookupSearch: ${error}`);
        return Observable.throw(error);
      })
      .map((res: List<AgencyLookupSummary>) => {
        this.mySearchResults.next(res);
        return res;
      })
  }

  getDetail(summaryRecord: AgencyLookupSummary): Observable<AgencyLookupDetail> {
    this.logService.debug(`summaryRecord: ${JSON.stringify(summaryRecord)}`);

    return this.propertyLookupService.getDetail(summaryRecord)
      .catch((error: any) => {
        this.flashMessagesService.error('MESSAGES.ERROR.AGENCY_LOOKUP_GET_DETAILS', `Error retrieving AgencyLookupDetail: ${error}`);
        return Observable.throw(error);
      })
      .map((res: AgencyLookupDetail) => {
        this.mySelectedResults.next(res);
        return res;
      });
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/lookup/agency-lookup/agency-lookup.store.ts